export const locale = {
    lang: 'tr',
    data: {
      'FILEMANAGER': {
        'TITULO': 'Dosya yöneticisi',
        'SUBTI': 'Şirketinizle alakalı dosyaları yükleyin',
        'GPTW': {
          'TITULO': 'Yüklenen dosyalar listesini göstermek için bir şirket adını tıklayın',
          'NUMFILES': 'Yüklenen dosya sayısı:'
        },
        'CT_NAME':'Şiddetli travmatik olay yaşayan işbirlikçiler',
        'LABEL01':'  İş Merkezleri',
        'CARGA': {
          'TITULO': 'Bir dosya yüklemek için burayı tıklayın veya buraya sürükleyip bırakın',
          'CARGANDOTIT': 'Yükleme',
          'CARGANTOTXT': 'Dosya veritabanına gönderiliyor. Lütfen biraz bekleyin.'
        },
        'MENU': {
          'BOTON': 'Yeni',
          'ARCHIVO': 'Dosya',
          'CARPETA': 'Klasör',
          'EXCELTI': 'Excel TI\'yi indirin'
        },
        'LISTA': {
          'TITULOS': {
            'NOMBRE': 'ad',
            'EXTEN': 'Uzantı',
            'FECHA': 'yükleme tarihi',
            'ACCIONES': 'Hareketler',
            'TAMANIO': 'Boyut'
          },
           // Temporales
          'TITULOSENC':{
            'NOMBRE': 'Ortak çalışan adı:',
            'ARCH':'Dosya adı',
            'DATE': 'Güncelleme Tarihi',
            'EXTEN': 'İş merkezi adı:',
            'ACT': 'Hareketler',
            'BT':'Ev'
          },
          'TOOLTIP': {
            'DESCARGA': 'Bu dosyayı indir',
            'DELETE': 'Bu dosyayı sil',
            'OPENFOLDER': 'Bu klasörü açmak için buraya tıklayın',
            'VACIO': 'Bu klasör boş'
          }
        },
        'MENSAJES': {
          'CARGAOK': 'Dosya başarıyla kaydedildi',
          'CARGAREP': 'Dosya kaydedilmedi. Aynı ada sahip bir dosya zaten var',
          'DELETERLY': 'Bu dosyayı silmeyi onaylıyor musunuz?',
          'DELETEOK': 'Dosya doğru bir şekilde silindi',
          'CREATEFOLDER': 'Yeni klasörün adını girin',
          'FOLDEROK': 'Klasör başarıyla oluşturuldu.',
          'archivo_save_4': 'Klasör oluşturulamadı. Aynı ada sahip bir klasör zaten var',
          'DELETEFOLDERRLY': 'Bu klasörü silmeyi onaylıyor musunuz? \n\n nUyarı: Bu klasörün içeriği de silinecek',
          'DELETEFOLDEROK': 'Klasör, içeriğiyle birlikte başarıyla silindi',
          'INVALID_CHARS': 'Klasör adı yalnızca A\'dan Z\'ye kadar olan karakterler ve rakamlardan oluşabilir.',
          'BOTONES': {
            'SI': 'Evet',
            'NO': 'Hayır',
            'ACEPTAR': 'Kabul etmek',
            'CREAR': 'Oluşturmak',
            'CANCELAR': 'İptal etmek'
          }
        },
        'CARPETASDEFAULT':{
          'Información TI': 'TI Bilgi',
          'Información CA': 'CA Bilgileri',
          'Información General': 'Genel bilgi',
          'Comunicación NOM035': 'NOM035 İletişim',
          'Plantilla listado colaboradores': 'Ortak çalışanlar listesi şablonu',
          'Campaña de Comunicación 2020': 'İletişim kampanyası',
          // 'Culture Audit': 'Kültür Denetimi',
          'Guía de certificación': 'Sertifika kılavuzu',
          'Listado de colaboradores': 'Ortak çalışanlar listesi',
          'Plantillas': 'Templates',
          'Templates con TI': 'Templates with IT',
          'Templates Página' : 'Page templates',
          'Certificar' : 'Certify',
          'Focus Area' : 'Focus Area',
          'Medir' : 'Measurement',
          'Pulsecheck' : 'Pulse Check',
          'Row Data': 'Row Data',
          'Reports': 'Raporlar',

          'Campana de Comunicacion': 'iletişim kampanyası',
          'Culture Audit': 'Kültür Denetimi™',
          'Great Book': 'Harika kitap',
          'Cuestionarios': 'anketler',
          'Pulse Check': 'Kontrole basın',
          'Base de datos': 'Veri tabanı',
          'Practicas For All': 'Herkes İçin Staj',
          'Reporte de Resultados': 'Sonuç raporu',
          'Validacion': 'doğrulama',
        }
      }
    }
};
